import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _64c4997a = () => interopDefault(import('../pages/403/index.vue' /* webpackChunkName: "pages/403/index" */))
const _43775ee2 = () => interopDefault(import('../pages/adminDashboard/index.vue' /* webpackChunkName: "pages/adminDashboard/index" */))
const _55198319 = () => interopDefault(import('../pages/affiliate/index.vue' /* webpackChunkName: "pages/affiliate/index" */))
const _42a63ba0 = () => interopDefault(import('../pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _4d817e9b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _4906b7a3 = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _2c52277a = () => interopDefault(import('../pages/files/index.vue' /* webpackChunkName: "pages/files/index" */))
const _02ba3428 = () => interopDefault(import('../pages/forgotPassword/index.vue' /* webpackChunkName: "pages/forgotPassword/index" */))
const _2c56f38b = () => interopDefault(import('../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _0cb15ff3 = () => interopDefault(import('../pages/ledger/index.vue' /* webpackChunkName: "pages/ledger/index" */))
const _6d37d0f4 = () => interopDefault(import('../pages/locationOrganizer/index.vue' /* webpackChunkName: "pages/locationOrganizer/index" */))
const _4423ca96 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _1b0c1d11 = () => interopDefault(import('../pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _09f97d70 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _5d6f6a6f = () => interopDefault(import('../pages/orders/index.vue' /* webpackChunkName: "pages/orders/index" */))
const _2a2e1d6a = () => interopDefault(import('../pages/reports/index.vue' /* webpackChunkName: "pages/reports/index" */))
const _f525e072 = () => interopDefault(import('../pages/scan/index.vue' /* webpackChunkName: "pages/scan/index" */))
const _36e45d75 = () => interopDefault(import('../pages/wizard/index.vue' /* webpackChunkName: "pages/wizard/index" */))
const _0f67568f = () => interopDefault(import('../pages/account/settings/index.vue' /* webpackChunkName: "pages/account/settings/index" */))
const _5a157e64 = () => interopDefault(import('../pages/adminDashboard/custom-invoice.vue' /* webpackChunkName: "pages/adminDashboard/custom-invoice" */))
const _e66e034e = () => interopDefault(import('../pages/adminDashboard/email.vue' /* webpackChunkName: "pages/adminDashboard/email" */))
const _6c697e94 = () => interopDefault(import('../pages/adminDashboard/flex-credit-memos.vue' /* webpackChunkName: "pages/adminDashboard/flex-credit-memos" */))
const _b43f388e = () => interopDefault(import('../pages/adminDashboard/payout.vue' /* webpackChunkName: "pages/adminDashboard/payout" */))
const _0346c2bc = () => interopDefault(import('../pages/adminDashboard/presale-invoices.vue' /* webpackChunkName: "pages/adminDashboard/presale-invoices" */))
const _36298d72 = () => interopDefault(import('../pages/adminDashboard/rolesAndPermissions.vue' /* webpackChunkName: "pages/adminDashboard/rolesAndPermissions" */))
const _e91739e2 = () => interopDefault(import('../pages/dashboard/editor.vue' /* webpackChunkName: "pages/dashboard/editor" */))
const _724ebed8 = () => interopDefault(import('../pages/dashboard/inProgress.vue' /* webpackChunkName: "pages/dashboard/inProgress" */))
const _144503cd = () => interopDefault(import('../pages/dashboard/inProgress1.vue' /* webpackChunkName: "pages/dashboard/inProgress1" */))
const _14531b4e = () => interopDefault(import('../pages/dashboard/inProgress2.vue' /* webpackChunkName: "pages/dashboard/inProgress2" */))
const _4fe68d53 = () => interopDefault(import('../pages/events/archive.vue' /* webpackChunkName: "pages/events/archive" */))
const _00f6f10a = () => interopDefault(import('../pages/events/create.vue' /* webpackChunkName: "pages/events/create" */))
const _34ee368a = () => interopDefault(import('../pages/events/current.vue' /* webpackChunkName: "pages/events/current" */))
const _26135825 = () => interopDefault(import('../pages/events/history.vue' /* webpackChunkName: "pages/events/history" */))
const _7821d078 = () => interopDefault(import('../pages/events/media/index.vue' /* webpackChunkName: "pages/events/media/index" */))
const _6595b4b2 = () => interopDefault(import('../pages/forgotPassword/sent.vue' /* webpackChunkName: "pages/forgotPassword/sent" */))
const _078986a9 = () => interopDefault(import('../pages/login/create.vue' /* webpackChunkName: "pages/login/create" */))
const _7b31b924 = () => interopDefault(import('../pages/media/categories.vue' /* webpackChunkName: "pages/media/categories" */))
const _269c96d6 = () => interopDefault(import('../pages/media/files.vue' /* webpackChunkName: "pages/media/files" */))
const _083f6dfe = () => interopDefault(import('../pages/orders/all/index.vue' /* webpackChunkName: "pages/orders/all/index" */))
const _90adf3d8 = () => interopDefault(import('../pages/subscriptions/all/index.vue' /* webpackChunkName: "pages/subscriptions/all/index" */))
const _0c7750b0 = () => interopDefault(import('../pages/ticket/create.vue' /* webpackChunkName: "pages/ticket/create" */))
const _2e882b0c = () => interopDefault(import('../pages/events/media/editor/index.vue' /* webpackChunkName: "pages/events/media/editor/index" */))
const _3734dfd8 = () => interopDefault(import('../pages/orders/events/upcomming.vue' /* webpackChunkName: "pages/orders/events/upcomming" */))
const _1e43d765 = () => interopDefault(import('../pages/subscriptions/events/upcomming.vue' /* webpackChunkName: "pages/subscriptions/events/upcomming" */))
const _3ce78c02 = () => interopDefault(import('../pages/subscriptions/view/cancel/_id.vue' /* webpackChunkName: "pages/subscriptions/view/cancel/_id" */))
const _4a82f76a = () => interopDefault(import('../pages/subscriptions/payment/stripe/_orderIncrementId/_pi.vue' /* webpackChunkName: "pages/subscriptions/payment/stripe/_orderIncrementId/_pi" */))
const _1415ec74 = () => interopDefault(import('../pages/events/edit/_id.vue' /* webpackChunkName: "pages/events/edit/_id" */))
const _6b00ee0f = () => interopDefault(import('../pages/events/view/_id.vue' /* webpackChunkName: "pages/events/view/_id" */))
const _e366197a = () => interopDefault(import('../pages/login/public/_token.vue' /* webpackChunkName: "pages/login/public/_token" */))
const _60da6984 = () => interopDefault(import('../pages/orders/invoices/_id.vue' /* webpackChunkName: "pages/orders/invoices/_id" */))
const _47d99491 = () => interopDefault(import('../pages/orders/payment/_id/index.vue' /* webpackChunkName: "pages/orders/payment/_id/index" */))
const _6edfb7c3 = () => interopDefault(import('../pages/orders/view/_id.vue' /* webpackChunkName: "pages/orders/view/_id" */))
const _06052f91 = () => interopDefault(import('../pages/subscriptions/invoices/_id.vue' /* webpackChunkName: "pages/subscriptions/invoices/_id" */))
const _7e097ec1 = () => interopDefault(import('../pages/subscriptions/item/_id/index.vue' /* webpackChunkName: "pages/subscriptions/item/_id/index" */))
const _42a98ea4 = () => interopDefault(import('../pages/subscriptions/payment/_id/index.vue' /* webpackChunkName: "pages/subscriptions/payment/_id/index" */))
const _01518c50 = () => interopDefault(import('../pages/subscriptions/view/_id.vue' /* webpackChunkName: "pages/subscriptions/view/_id" */))
const _3cd8f68e = () => interopDefault(import('../pages/account/settings/_field/_token/index.vue' /* webpackChunkName: "pages/account/settings/_field/_token/index" */))
const _60ec5a7a = () => interopDefault(import('../pages/customer/events/_eventId/_orderItemId.vue' /* webpackChunkName: "pages/customer/events/_eventId/_orderItemId" */))
const _1861484c = () => interopDefault(import('../pages/orders/payment/_id/_payment_method/_status.vue' /* webpackChunkName: "pages/orders/payment/_id/_payment_method/_status" */))
const _1ffa172d = () => interopDefault(import('../pages/subscriptions/payment/_id/_payment_method/_status.vue' /* webpackChunkName: "pages/subscriptions/payment/_id/_payment_method/_status" */))
const _02b41c8e = () => interopDefault(import('../pages/autologin/_id.vue' /* webpackChunkName: "pages/autologin/_id" */))
const _28ea9fde = () => interopDefault(import('../pages/check-in/_locationId.vue' /* webpackChunkName: "pages/check-in/_locationId" */))
const _35806f42 = () => interopDefault(import('../pages/files/_orderItemId/index.vue' /* webpackChunkName: "pages/files/_orderItemId/index" */))
const _d12dce82 = () => interopDefault(import('../pages/Link/_hash.vue' /* webpackChunkName: "pages/Link/_hash" */))
const _6baae0c6 = () => interopDefault(import('../pages/locationOrganizer/_locationId/index.vue' /* webpackChunkName: "pages/locationOrganizer/_locationId/index" */))
const _659cd3a7 = () => interopDefault(import('../pages/login/_token.vue' /* webpackChunkName: "pages/login/_token" */))
const _78133f4a = () => interopDefault(import('../pages/media/_id/index.vue' /* webpackChunkName: "pages/media/_id/index" */))
const _b2eaf71c = () => interopDefault(import('../pages/ticket/_customerMembershipId.vue' /* webpackChunkName: "pages/ticket/_customerMembershipId" */))
const _0f8a8850 = () => interopDefault(import('../pages/locationOrganizer/_locationId/all/index.vue' /* webpackChunkName: "pages/locationOrganizer/_locationId/all/index" */))
const _b9bc0946 = () => interopDefault(import('../pages/locationOrganizer/_locationId/ticket-stats/index.vue' /* webpackChunkName: "pages/locationOrganizer/_locationId/ticket-stats/index" */))
const _d6c4cc34 = () => interopDefault(import('../pages/scan/_hash/public.vue' /* webpackChunkName: "pages/scan/_hash/public" */))
const _01978e27 = () => interopDefault(import('../pages/locationOrganizer/_locationId/event/_eventId.vue' /* webpackChunkName: "pages/locationOrganizer/_locationId/event/_eventId" */))
const _7bc5f3e7 = () => interopDefault(import('../pages/files/_orderItemId/_eventDateId.vue' /* webpackChunkName: "pages/files/_orderItemId/_eventDateId" */))
const _5120af2a = () => interopDefault(import('../pages/media/_id/_eventDateId.vue' /* webpackChunkName: "pages/media/_id/_eventDateId" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/403",
    component: _64c4997a,
    name: "403___de"
  }, {
    path: "/adminDashboard",
    component: _43775ee2,
    name: "adminDashboard___de"
  }, {
    path: "/affiliate",
    component: _55198319,
    name: "affiliate___de"
  }, {
    path: "/dashboard",
    component: _42a63ba0,
    name: "dashboard___de"
  }, {
    path: "/en",
    component: _4d817e9b,
    name: "index___en"
  }, {
    path: "/events",
    component: _4906b7a3,
    name: "events___de"
  }, {
    path: "/files",
    component: _2c52277a,
    name: "files___de"
  }, {
    path: "/forgotPassword",
    component: _02ba3428,
    name: "forgotPassword___de"
  }, {
    path: "/help",
    component: _2c56f38b,
    name: "help___de"
  }, {
    path: "/ledger",
    component: _0cb15ff3,
    name: "ledger___de"
  }, {
    path: "/locationOrganizer",
    component: _6d37d0f4,
    name: "locationOrganizer___de"
  }, {
    path: "/login",
    component: _4423ca96,
    name: "login___de"
  }, {
    path: "/logout",
    component: _1b0c1d11,
    name: "logout___de"
  }, {
    path: "/media",
    component: _09f97d70,
    name: "media___de"
  }, {
    path: "/orders",
    component: _5d6f6a6f,
    name: "orders___de"
  }, {
    path: "/reports",
    component: _2a2e1d6a,
    name: "reports___de"
  }, {
    path: "/scan",
    component: _f525e072,
    name: "scan___de"
  }, {
    path: "/wizard",
    component: _36e45d75,
    name: "wizard___de"
  }, {
    path: "/account/settings",
    component: _0f67568f,
    name: "account-settings___de"
  }, {
    path: "/adminDashboard/custom-invoice",
    component: _5a157e64,
    name: "adminDashboard-custom-invoice___de"
  }, {
    path: "/adminDashboard/email",
    component: _e66e034e,
    name: "adminDashboard-email___de"
  }, {
    path: "/adminDashboard/flex-credit-memos",
    component: _6c697e94,
    name: "adminDashboard-flex-credit-memos___de"
  }, {
    path: "/adminDashboard/payout",
    component: _b43f388e,
    name: "adminDashboard-payout___de"
  }, {
    path: "/adminDashboard/presale-invoices",
    component: _0346c2bc,
    name: "adminDashboard-presale-invoices___de"
  }, {
    path: "/adminDashboard/rolesAndPermissions",
    component: _36298d72,
    name: "adminDashboard-rolesAndPermissions___de"
  }, {
    path: "/dashboard/editor",
    component: _e91739e2,
    name: "dashboard-editor___de"
  }, {
    path: "/dashboard/inProgress",
    component: _724ebed8,
    name: "dashboard-inProgress___de"
  }, {
    path: "/dashboard/inProgress1",
    component: _144503cd,
    name: "dashboard-inProgress1___de"
  }, {
    path: "/dashboard/inProgress2",
    component: _14531b4e,
    name: "dashboard-inProgress2___de"
  }, {
    path: "/en/403",
    component: _64c4997a,
    name: "403___en"
  }, {
    path: "/en/adminDashboard",
    component: _43775ee2,
    name: "adminDashboard___en"
  }, {
    path: "/en/affiliate",
    component: _55198319,
    name: "affiliate___en"
  }, {
    path: "/en/dashboard",
    component: _42a63ba0,
    name: "dashboard___en"
  }, {
    path: "/en/events",
    component: _4906b7a3,
    name: "events___en"
  }, {
    path: "/en/files",
    component: _2c52277a,
    name: "files___en"
  }, {
    path: "/en/forgotPassword",
    component: _02ba3428,
    name: "forgotPassword___en"
  }, {
    path: "/en/help",
    component: _2c56f38b,
    name: "help___en"
  }, {
    path: "/en/ledger",
    component: _0cb15ff3,
    name: "ledger___en"
  }, {
    path: "/en/locationOrganizer",
    component: _6d37d0f4,
    name: "locationOrganizer___en"
  }, {
    path: "/en/login",
    component: _4423ca96,
    name: "login___en"
  }, {
    path: "/en/logout",
    component: _1b0c1d11,
    name: "logout___en"
  }, {
    path: "/en/media",
    component: _09f97d70,
    name: "media___en"
  }, {
    path: "/en/orders",
    component: _5d6f6a6f,
    name: "orders___en"
  }, {
    path: "/en/reports",
    component: _2a2e1d6a,
    name: "reports___en"
  }, {
    path: "/en/scan",
    component: _f525e072,
    name: "scan___en"
  }, {
    path: "/en/wizard",
    component: _36e45d75,
    name: "wizard___en"
  }, {
    path: "/events/archive",
    component: _4fe68d53,
    name: "events-archive___de"
  }, {
    path: "/events/create",
    component: _00f6f10a,
    name: "events-create___de"
  }, {
    path: "/events/current",
    component: _34ee368a,
    name: "events-current___de"
  }, {
    path: "/events/history",
    component: _26135825,
    name: "events-history___de"
  }, {
    path: "/events/media",
    component: _7821d078,
    name: "events-media___de"
  }, {
    path: "/forgotPassword/sent",
    component: _6595b4b2,
    name: "forgotPassword-sent___de"
  }, {
    path: "/login/create",
    component: _078986a9,
    name: "login-create___de"
  }, {
    path: "/media/categories",
    component: _7b31b924,
    name: "media-categories___de"
  }, {
    path: "/media/files",
    component: _269c96d6,
    name: "media-files___de"
  }, {
    path: "/orders/all",
    component: _083f6dfe,
    name: "orders-all___de"
  }, {
    path: "/subscriptions/all",
    component: _90adf3d8,
    name: "subscriptions-all___de"
  }, {
    path: "/ticket/create",
    component: _0c7750b0,
    name: "ticket-create___de"
  }, {
    path: "/en/account/settings",
    component: _0f67568f,
    name: "account-settings___en"
  }, {
    path: "/en/adminDashboard/custom-invoice",
    component: _5a157e64,
    name: "adminDashboard-custom-invoice___en"
  }, {
    path: "/en/adminDashboard/email",
    component: _e66e034e,
    name: "adminDashboard-email___en"
  }, {
    path: "/en/adminDashboard/flex-credit-memos",
    component: _6c697e94,
    name: "adminDashboard-flex-credit-memos___en"
  }, {
    path: "/en/adminDashboard/payout",
    component: _b43f388e,
    name: "adminDashboard-payout___en"
  }, {
    path: "/en/adminDashboard/presale-invoices",
    component: _0346c2bc,
    name: "adminDashboard-presale-invoices___en"
  }, {
    path: "/en/adminDashboard/rolesAndPermissions",
    component: _36298d72,
    name: "adminDashboard-rolesAndPermissions___en"
  }, {
    path: "/en/dashboard/editor",
    component: _e91739e2,
    name: "dashboard-editor___en"
  }, {
    path: "/en/dashboard/inProgress",
    component: _724ebed8,
    name: "dashboard-inProgress___en"
  }, {
    path: "/en/dashboard/inProgress1",
    component: _144503cd,
    name: "dashboard-inProgress1___en"
  }, {
    path: "/en/dashboard/inProgress2",
    component: _14531b4e,
    name: "dashboard-inProgress2___en"
  }, {
    path: "/en/events/archive",
    component: _4fe68d53,
    name: "events-archive___en"
  }, {
    path: "/en/events/create",
    component: _00f6f10a,
    name: "events-create___en"
  }, {
    path: "/en/events/current",
    component: _34ee368a,
    name: "events-current___en"
  }, {
    path: "/en/events/history",
    component: _26135825,
    name: "events-history___en"
  }, {
    path: "/en/events/media",
    component: _7821d078,
    name: "events-media___en"
  }, {
    path: "/en/forgotPassword/sent",
    component: _6595b4b2,
    name: "forgotPassword-sent___en"
  }, {
    path: "/en/login/create",
    component: _078986a9,
    name: "login-create___en"
  }, {
    path: "/en/media/categories",
    component: _7b31b924,
    name: "media-categories___en"
  }, {
    path: "/en/media/files",
    component: _269c96d6,
    name: "media-files___en"
  }, {
    path: "/en/orders/all",
    component: _083f6dfe,
    name: "orders-all___en"
  }, {
    path: "/en/subscriptions/all",
    component: _90adf3d8,
    name: "subscriptions-all___en"
  }, {
    path: "/en/ticket/create",
    component: _0c7750b0,
    name: "ticket-create___en"
  }, {
    path: "/events/media/editor",
    component: _2e882b0c,
    name: "events-media-editor___de"
  }, {
    path: "/orders/events/upcomming",
    component: _3734dfd8,
    name: "orders-events-upcomming___de"
  }, {
    path: "/subscriptions/events/upcomming",
    component: _1e43d765,
    name: "subscriptions-events-upcomming___de"
  }, {
    path: "/en/events/media/editor",
    component: _2e882b0c,
    name: "events-media-editor___en"
  }, {
    path: "/en/orders/events/upcomming",
    component: _3734dfd8,
    name: "orders-events-upcomming___en"
  }, {
    path: "/en/subscriptions/events/upcomming",
    component: _1e43d765,
    name: "subscriptions-events-upcomming___en"
  }, {
    path: "/en/subscriptions/view/cancel/:id?",
    component: _3ce78c02,
    name: "subscriptions-view-cancel-id___en"
  }, {
    path: "/en/subscriptions/payment/stripe/:orderIncrementId?/:pi?",
    component: _4a82f76a,
    name: "subscriptions-payment-stripe-orderIncrementId-pi___en"
  }, {
    path: "/en/events/edit/:id?",
    component: _1415ec74,
    name: "events-edit-id___en"
  }, {
    path: "/en/events/view/:id?",
    component: _6b00ee0f,
    name: "events-view-id___en"
  }, {
    path: "/en/login/public/:token?",
    component: _e366197a,
    name: "login-public-token___en"
  }, {
    path: "/en/orders/invoices/:id?",
    component: _60da6984,
    name: "orders-invoices-id___en"
  }, {
    path: "/en/orders/payment/:id?",
    component: _47d99491,
    name: "orders-payment-id___en"
  }, {
    path: "/en/orders/view/:id?",
    component: _6edfb7c3,
    name: "orders-view-id___en"
  }, {
    path: "/en/subscriptions/invoices/:id?",
    component: _06052f91,
    name: "subscriptions-invoices-id___en"
  }, {
    path: "/en/subscriptions/item/:id?",
    component: _7e097ec1,
    name: "subscriptions-item-id___en"
  }, {
    path: "/en/subscriptions/payment/:id?",
    component: _42a98ea4,
    name: "subscriptions-payment-id___en"
  }, {
    path: "/en/subscriptions/view/:id?",
    component: _01518c50,
    name: "subscriptions-view-id___en"
  }, {
    path: "/subscriptions/view/cancel/:id?",
    component: _3ce78c02,
    name: "subscriptions-view-cancel-id___de"
  }, {
    path: "/en/account/settings/:field/:token?",
    component: _3cd8f68e,
    name: "account-settings-field-token___en"
  }, {
    path: "/en/customer/events/:eventId?/:orderItemId?",
    component: _60ec5a7a,
    name: "customer-events-eventId-orderItemId___en"
  }, {
    path: "/subscriptions/payment/stripe/:orderIncrementId?/:pi?",
    component: _4a82f76a,
    name: "subscriptions-payment-stripe-orderIncrementId-pi___de"
  }, {
    path: "/en/orders/payment/:id?/:payment_method/:status?",
    component: _1861484c,
    name: "orders-payment-id-payment_method-status___en"
  }, {
    path: "/en/subscriptions/payment/:id?/:payment_method/:status?",
    component: _1ffa172d,
    name: "subscriptions-payment-id-payment_method-status___en"
  }, {
    path: "/en/autologin/:id?",
    component: _02b41c8e,
    name: "autologin-id___en"
  }, {
    path: "/en/check-in/:locationId?",
    component: _28ea9fde,
    name: "check-in-locationId___en"
  }, {
    path: "/en/files/:orderItemId",
    component: _35806f42,
    name: "files-orderItemId___en"
  }, {
    path: "/en/Link/:hash?",
    component: _d12dce82,
    name: "Link-hash___en"
  }, {
    path: "/en/locationOrganizer/:locationId",
    component: _6baae0c6,
    name: "locationOrganizer-locationId___en"
  }, {
    path: "/en/login/:token",
    component: _659cd3a7,
    name: "login-token___en"
  }, {
    path: "/en/media/:id",
    component: _78133f4a,
    name: "media-id___en"
  }, {
    path: "/en/ticket/:customerMembershipId?",
    component: _b2eaf71c,
    name: "ticket-customerMembershipId___en"
  }, {
    path: "/events/edit/:id?",
    component: _1415ec74,
    name: "events-edit-id___de"
  }, {
    path: "/events/view/:id?",
    component: _6b00ee0f,
    name: "events-view-id___de"
  }, {
    path: "/login/public/:token?",
    component: _e366197a,
    name: "login-public-token___de"
  }, {
    path: "/orders/invoices/:id?",
    component: _60da6984,
    name: "orders-invoices-id___de"
  }, {
    path: "/orders/payment/:id?",
    component: _47d99491,
    name: "orders-payment-id___de"
  }, {
    path: "/orders/view/:id?",
    component: _6edfb7c3,
    name: "orders-view-id___de"
  }, {
    path: "/subscriptions/invoices/:id?",
    component: _06052f91,
    name: "subscriptions-invoices-id___de"
  }, {
    path: "/subscriptions/item/:id?",
    component: _7e097ec1,
    name: "subscriptions-item-id___de"
  }, {
    path: "/subscriptions/payment/:id?",
    component: _42a98ea4,
    name: "subscriptions-payment-id___de"
  }, {
    path: "/subscriptions/view/:id?",
    component: _01518c50,
    name: "subscriptions-view-id___de"
  }, {
    path: "/en/locationOrganizer/:locationId/all",
    component: _0f8a8850,
    name: "locationOrganizer-locationId-all___en"
  }, {
    path: "/en/locationOrganizer/:locationId/ticket-stats",
    component: _b9bc0946,
    name: "locationOrganizer-locationId-ticket-stats___en"
  }, {
    path: "/en/scan/:hash/public",
    component: _d6c4cc34,
    name: "scan-hash-public___en"
  }, {
    path: "/en/locationOrganizer/:locationId/event/:eventId?",
    component: _01978e27,
    name: "locationOrganizer-locationId-event-eventId___en"
  }, {
    path: "/account/settings/:field/:token?",
    component: _3cd8f68e,
    name: "account-settings-field-token___de"
  }, {
    path: "/customer/events/:eventId?/:orderItemId?",
    component: _60ec5a7a,
    name: "customer-events-eventId-orderItemId___de"
  }, {
    path: "/en/files/:orderItemId/:eventDateId",
    component: _7bc5f3e7,
    name: "files-orderItemId-eventDateId___en"
  }, {
    path: "/en/media/:id/:eventDateId",
    component: _5120af2a,
    name: "media-id-eventDateId___en"
  }, {
    path: "/orders/payment/:id?/:payment_method/:status?",
    component: _1861484c,
    name: "orders-payment-id-payment_method-status___de"
  }, {
    path: "/subscriptions/payment/:id?/:payment_method/:status?",
    component: _1ffa172d,
    name: "subscriptions-payment-id-payment_method-status___de"
  }, {
    path: "/autologin/:id?",
    component: _02b41c8e,
    name: "autologin-id___de"
  }, {
    path: "/check-in/:locationId?",
    component: _28ea9fde,
    name: "check-in-locationId___de"
  }, {
    path: "/files/:orderItemId",
    component: _35806f42,
    name: "files-orderItemId___de"
  }, {
    path: "/Link/:hash?",
    component: _d12dce82,
    name: "Link-hash___de"
  }, {
    path: "/locationOrganizer/:locationId",
    component: _6baae0c6,
    name: "locationOrganizer-locationId___de"
  }, {
    path: "/login/:token",
    component: _659cd3a7,
    name: "login-token___de"
  }, {
    path: "/media/:id",
    component: _78133f4a,
    name: "media-id___de"
  }, {
    path: "/ticket/:customerMembershipId?",
    component: _b2eaf71c,
    name: "ticket-customerMembershipId___de"
  }, {
    path: "/locationOrganizer/:locationId/all",
    component: _0f8a8850,
    name: "locationOrganizer-locationId-all___de"
  }, {
    path: "/locationOrganizer/:locationId/ticket-stats",
    component: _b9bc0946,
    name: "locationOrganizer-locationId-ticket-stats___de"
  }, {
    path: "/scan/:hash/public",
    component: _d6c4cc34,
    name: "scan-hash-public___de"
  }, {
    path: "/locationOrganizer/:locationId/event/:eventId?",
    component: _01978e27,
    name: "locationOrganizer-locationId-event-eventId___de"
  }, {
    path: "/files/:orderItemId/:eventDateId",
    component: _7bc5f3e7,
    name: "files-orderItemId-eventDateId___de"
  }, {
    path: "/media/:id/:eventDateId",
    component: _5120af2a,
    name: "media-id-eventDateId___de"
  }, {
    path: "/",
    component: _4d817e9b,
    name: "index___de"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
